$(document).ready(function () {

    function registerInterest(topLevelElement, id, token, type){

        $("#application-response-select-"+id).on("change", function () {

            var applicationResponse = $(this).val();
            var $selector = $(this).closest('.response-status-selector');

            $selector.find('.modal-overlay').show();
            $selector.attr('application-id', id);
            $selector.attr('response-id', applicationResponse);
        });

        $('#confirm-application-'+id).click(function() {
            var $selector = $(this).closest('.response-status-selector');

            var applicationResponse = $selector.attr('response-id');

            $selector.find('.selector-input').attr('data-application-response', applicationResponse);

            if(type == 'innovation'){
                var url = '/api/v1/network/'+networkSlug+'/innovation/' + id + '/update?application_response_id=' + applicationResponse;
            } else {
                var url = '/api/v1/network/'+networkSlug+'/user/' + id + '/update?application_response_id=' + applicationResponse;
            }

            var data = {
                sendEmail: $selector.find('.send-email').prop('checked'),
                customMessage: $selector.find('#custom-message').val(),
                responseId: applicationResponse
            }

            axios.patch(url, data).then((response) => {
                $selector.find('.modal-overlay').hide();

                $("body").append('<div class="flash success">'+response.data.success+'</div>');
                setTimeout(function(){
                    $('.flash.success').remove();
                }, 2000);
            }).catch(function (error) {
                $("body").append('<div class="flash error">'+response.data.error+'</div>');
                setTimeout(function(){
                    $('.flash.error').remove();
                }, 2000);
            });
        });

        $('#send-email-'+id).on("change",function() {
            var status = $(this).prop('checked');
            if(status){
                $(this).closest('.response-status-selector').find('.custom-message').show();
            }else{
                $(this).closest('.response-status-selector').find('.custom-message').hide();
            }
        });
    }

    if ($('.network-vetting').length) {
        $('tr').each(function(){
            var topLevelElement = $(this);
            var id = $(this).attr('data-id');
            var token = $(this).attr("data-token");
            var type = $(this).attr("data-type");

            registerInterest(topLevelElement, id, token, type);
        });

        $('.cards .card').each(function(){
            var topLevelElement = $(this);
            var id = $(this).attr('data-id');
            var token = $(this).attr("data-token");
            var type = $(this).attr("data-type");

            registerInterest(topLevelElement, id, token, type);
        });
    }

    if($('.network-application-view').length){

        var topLevelElement = $('#interest-component');
        var id = $('#interest-component').attr('data-id');
        var token = $('#interest-component').attr("data-token");
        var type = $('#interest-component').attr("data-type");

        registerInterest(topLevelElement, id, token, type);
    }
});